module.exports = __webpack_public_path__ + "static/media/siri04.39383a53.jpg";